import {connect} from 'react-redux';

import {DropdownItemProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {TeamModel} from '../../../models/api/teamModel';
import {AppState} from '../../../store/appState';
import {makeGetActiveTeammatesForTeam} from '../../../store/data/teammates/teammatesSelectors';
import {TeamDropdownItem} from './teamDropdownItem';

/*
 * Props.
 */

interface TeamDropdownItemContainerProps extends DropdownItemProps {
  team: TeamModel;
  shouldRenderVisibilityDescription?: boolean;
}

/*
 * Selectors.
 */

function getTeam(_state: AppState, props: TeamDropdownItemContainerProps) {
  return props.team;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeamDropdownItemContainerProps>()(() => ({
  activeTeammatesForTeam: makeGetActiveTeammatesForTeam(getTeam),
}));

export const TeamDropdownItemContainer = connect(mapStateToProps)(TeamDropdownItem);
